import { render } from "./ChangePassCode.vue?vue&type=template&id=4a1e5ba4&scoped=true"
import script from "./ChangePassCode.vue?vue&type=script&lang=js"
export * from "./ChangePassCode.vue?vue&type=script&lang=js"

import "./ChangePassCode.vue?vue&type=style&index=0&id=4a1e5ba4&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1e5ba4"]])

export default __exports__